import { toUrlR, URLParser } from '@execonline-inc/url';
import { identity } from '@kofno/piper';
import { array, Decoder, fail, field, number, oneOf, string, succeed } from 'jsonous';
import { nullableField } from '../../../Decoders';
import { resourceDecoder } from '../../Decoders';
import { Link } from '../../Types';
import { SelectionOption, SelectionOptionResource } from '../Types';

// Import only what's needed for selectionOptionDecoder and selectionOptionResourceDecoder
export const urlDecoder: Decoder<URLParser> = string
  .mapError((e) => `Error decoding URL: ${e}`)
  .andThen(
    (a) =>
      new Decoder(() =>
        toUrlR(a).mapError(() => `Expected a valid URL but received: ${JSON.stringify(a)}`),
      ),
  );

export const imageContentTypeDecoder: Decoder<string> = string.andThen((a) => {
  if (a.startsWith('image/')) {
    return succeed(a);
  }
  return fail(
    `Expected a string content type matching "image/*", but received ${JSON.stringify(a)}`,
  );
});

export const optionImageDecoder: Decoder<any> = succeed({})
  .assign('type', field('type', imageContentTypeDecoder))
  .assign('data', field('data', string))
  .assign('src', field('src', urlDecoder))
  .assign('alt', field('alt', string));

const valueDecoder: Decoder<string> = oneOf<string | number>([
  string.map<string | number>(identity),
  number.map<string | number>(identity),
]).map(String);

const linkDecoder: Decoder<Link> = new Decoder((u) =>
  resourceDecoder(succeed({}))
    .decodeAny([u])
    .map((a) => a as unknown as Link)
    .mapError(() => `Expected a valid Link object, but instead got ${JSON.stringify(u)}`),
);

// Export the decoders that are needed by other files
export const selectionOptionDecoder: Decoder<SelectionOption> = succeed({})
  .assign('label', field('label', string))
  .assign('value', field('value', valueDecoder))
  .assign('image', nullableField('image', optionImageDecoder))
  .assign('link', nullableField('link', linkDecoder));

export const selectionOptionResourceDecoder: Decoder<SelectionOptionResource> = resourceDecoder(
  array(selectionOptionDecoder),
);
